import {
	Button
} from '@mui/material';
import dayjs from 'dayjs';
import strings from '../Globalization/index';
import { dataStore } from '../Store';
import consts from '../consts';
import Model from '../models/model';
import util from '../util';

const removeColumnOnGrid = () => {
	const { auth = {} } = dataStore.getState();
	const { tags = {} } = auth;
	return !tags.ProductType.includes('catviewer')
}

const { bIResultRenderer } = util;


const getEndoValue = (value) =>
	typeof value === 'string'
		? value
			.split(',')
			.filter((val) => val.trim().length > 0 && val !== 'undefined')
			.join(',')
		: value

export const model = new Model({
	name: 'EndoCycles',
	api: 'EndoCycles',
	idProperty: 'id',
	defaultSort: 'CycleStart DESC',
	disableAdd: true,
	disableDelete: true,
	formTitleField: 'CycleName',
	gridRefreshInterval: 300000,
	showGridRefreshBtn: true,
	combos: [
		{ type: 'Location', loaded: true }
	],
	columns: [
		{ field: 'CycleId', header: 'UniqueId', width: 250, hide: true },
		{ field: 'EquipmentName', header: 'EquipmentName', width: 150 },
		{ field: 'EquipmentTypeName', header: 'EquipmentTypeName', width: 150 ,hide:true },
		{ field: 'ModelName', header: 'ModalName', width: 200 },
		{ field: 'SerialNumber', header: 'SerialNumber', width: 180 },
		{ field: 'CycleName', header: 'CycleName', width: 190 },
		{ field: 'CycleCount', header: 'CycleCount', type: 'number', width: 150, valueFormatter: (value) => value?.toString().replace(/,/g, '') },
		{ field: 'CycleStatus', header: 'SterCycleStatus', width: 150, renderCell: bIResultRenderer },
		{ field: 'CycleStart', header: 'CycleDateTime', type: 'dateTime', width: 200 },
		{ field: 'InstrumentSN', header: 'EndoscopeID', width: 150, hide: true, valueGetter: getEndoValue, excludeOnGrid: removeColumnOnGrid },
		{ field: 'ModelNumber', header: 'EndoscopeType', width: 180, valueGetter: getEndoValue },
		{ field: 'InstrumentBarcode', header: 'EndoscopeBarcode', width: 160, valueGetter: getEndoValue },
		{ field: 'OperatorName', header: 'OperatorName', width: 260 },
		{ field: 'UnloadOperatorName', header: 'UnloadOperatorName', width: 150, hide: !removeColumnOnGrid },
		{ field: 'EndoscopeSerialNumber', header: 'EndoscopeSerialNumber', width: 180, valueGetter: getEndoValue },
		{
			field: 'startDate',
			header: 'StartDate',
			type: 'date',
			format: consts.MomentFormat.MonthDateYear,
			maxDate: ({ formik }) => (formik.values.endDate ? dayjs(formik.values.endDate) : dayjs()),
			hide: true,
			headerFilter: true,
			standaloneHeaderFilter: true,
			isNotFormfield: true,
			headerFilterWrapperProps: {
				xs: 6,
				container: true
			}
		},
		{
			field: 'endDate',
			header: 'EndDate',
			type: 'date',
			format: consts.MomentFormat.MonthDateYear,
			minDate: ({ formik }) => (formik.values.startDate ? dayjs(formik.values.startDate) : undefined),
			maxDate: () => dayjs(),
			headerFilter: true,
			standaloneHeaderFilter: true,
			isNotFormfield: true,
			headerFilterWrapperProps: {
				xs: 6,
				container: true
			}
		},
		{
			field: 'PrintTape',
			header: 'PreviewTape',
			width: 120,
			excludeOnGrid: ({ location }) => ['/cyclelist', '/dashboardcycles'].includes(location.pathname),
			renderCell: ({ row }) => (
				<Button variant="contained" title="Preview Tape" size="small" disabled={!row?.CycleTape}>
					{strings.PreviewTape}
				</Button>
			)
		}
	],
	extraExportConfig: {
		PDF: {
			pageSize: 'A2'
		}
	}
});

export default model.createFormBase();